import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useReducer, useRef, useEffect, useState, useMemo } from 'react';
import { Modal } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import { ENTITIES } from "../../lib/constants";
import { LOGEVENT_SUBMODULE } from "./constants";
import { getMappedFieldList } from "./lib";
import { publish } from "../../lib/EventBuser";
import { FIELDS_REFRESH } from "../../lib/events";
import { getList } from "../../lib/services/valueLists";
import { updateTabsOrder } from "../../lib/services/fields";
import { TransitionGroup, FadeTransition } from "../../components/Transitions";
import FieldsLists from "./FieldsLists";
import FormStandardField from "./FormStandardField";
import FormExtraField from "./FormExtraField";
import FormTab from "./FormTab";
import TabsLists from "./TabsLists";
import AddOnInfo from "../../components/Settings/AddOnInfo";
const reducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_TAB':
      state = _objectSpread(_objectSpread({}, state), {}, {
        activeTab: action.tab,
        activeShrinkedTab: null,
        entityLogSubmodule: action.entityLogSubmodule
      });
      return state;
    case 'CHANGE_SHRINKED_TAB':
      state = _objectSpread(_objectSpread({}, state), {}, {
        activeTab: action.value ? null : 'Empresas',
        activeShrinkedTab: action.value
      });
      return state;
    case 'SET_FIELDS_LIST_AND_ORDERS':
      state = _objectSpread(_objectSpread({}, state), {}, {
        fieldsData: _objectSpread(_objectSpread({}, state.fieldsData), {}, {
          [action.entity]: action.data
        })
      });
      return state;
    case 'SET_BRANCHES':
      state = _objectSpread(_objectSpread({}, state), {}, {
        branches: action.data
      });
      return state;
    case 'SET_TABS_MODAL':
      state = _objectSpread(_objectSpread({}, state), {}, {
        tabsModal: action.data
      });
      return state;
    case 'SET_EXTRA_ORDER':
      state = _objectSpread(_objectSpread({}, state), {}, {
        fieldsData: _objectSpread(_objectSpread({}, state.fieldsData), {}, {
          [action.entity]: _objectSpread(_objectSpread({}, state.fieldsData[action.entity]), {}, {
            extraOrder: _objectSpread(_objectSpread({}, state.fieldsData[action.entity].extraOrder), {}, {
              [action.tabId]: action.extraOrder
            })
          })
        })
      });
      return state;
    case 'SET_TABS_ORDER':
      state = _objectSpread(_objectSpread({}, state), {}, {
        tabsModal: {
          isOpen: false,
          order: []
        },
        fieldsData: _objectSpread(_objectSpread({}, state.fieldsData), {}, {
          [action.entity]: _objectSpread(_objectSpread({}, state.fieldsData[action.entity]), {}, {
            tabsOrder: action.tabsOrder
          })
        })
      });
      return state;
    case 'SET_UPGRADE_INFO_TABS':
      return _objectSpread(_objectSpread({}, state), {}, {
        isUpgradeInfoTabsOpen: action.value
      });
    case 'SET_UPGRADE_INFO_ADMIN':
      return _objectSpread(_objectSpread({}, state), {}, {
        isUpgradeInfoAdminOpen: action.value
      });
    default:
      return state;
  }
};
const initialState = {
  activeTab: ENTITIES.ACCOUNTS.fields,
  activeShrinkedTab: null,
  fieldsData: {},
  branches: null,
  tabsModal: {
    isOpen: false,
    order: []
  },
  entityLogSubmodule: 'accountsTab',
  isUpgradeInfoTabsOpen: false,
  isUpgradeInfoAdminOpen: false
};
const Fields = _ref => {
  var _state$tabsModal2, _state$fieldsData2, _overrides$formTabFie, _state$fieldsData3, _state$fieldsData3$en, _state$fieldsData3$en2, _state$tabsModal3;
  let {
    idSetupRole,
    overrides,
    onUpdate,
    contentLiteral,
    licenseEditionCode
  } = _ref;
  const {
    t,
    language,
    logEvent,
    customGeneralTab,
    overrideActiveTab,
    handleUpgradePlan,
    isWeb
  } = useWeb5Context({
    overrides
  });
  const formStandardField = useRef();
  const formExtraField = useRef();
  const formTab = useRef();
  const entityLogName = 'fields';
  const [state, dispatch] = useReducer(reducer, initialState);
  const [activeRowId, setActiveRowId] = useState(null);
  const isSage = useMemo(() => {
    var _licenseEditionCode$t;
    return licenseEditionCode === null || licenseEditionCode === void 0 ? void 0 : (_licenseEditionCode$t = licenseEditionCode.toLowerCase()) === null || _licenseEditionCode$t === void 0 ? void 0 : _licenseEditionCode$t.includes('sage');
  }, [licenseEditionCode]);
  useEffect(() => {
    if (state.branches) return;
    getList({
      list: 'tblSucursales',
      language
    }).then(_ref2 => {
      let {
        data
      } = _ref2;
      data = data.map(branch => ({
        value: branch.id,
        label: branch.description
      }));
      dispatch({
        type: 'SET_BRANCHES',
        data
      });
    }).catch(err => console.warn(err));
  }, [language, state.branches]);
  const entity = useMemo(() => state.activeTab || (state.activeShrinkedTab ? state.activeShrinkedTab.value : null), [state.activeShrinkedTab, state.activeTab]);
  const onChangeTab = useCallback(tab => {
    const submodule = LOGEVENT_SUBMODULE[tab] ? LOGEVENT_SUBMODULE[tab] : 'otherTablesTab';
    logEvent && logEvent({
      event: entityLogName,
      submodule: submodule,
      functionality: 'listView'
    });
    dispatch({
      type: 'CHANGE_TAB',
      tab,
      entityLogSubmodule: submodule
    });
  }, [logEvent]);
  const onChangeShrinked = useCallback(value => dispatch({
    type: 'CHANGE_SHRINKED_TAB',
    value
  }), [dispatch]);
  const onEditStandardField = useCallback((row, entities) => {
    var _state$activeShrinked;
    const entity = (state === null || state === void 0 ? void 0 : state.activeTab) || (state === null || state === void 0 ? void 0 : (_state$activeShrinked = state.activeShrinkedTab) === null || _state$activeShrinked === void 0 ? void 0 : _state$activeShrinked.value);
    setActiveRowId(row.id);
    formStandardField.current.open({
      idDb: row.idDb,
      entities,
      entity
    });
  }, [state]);
  const onCreateExtraField = useCallback(entities => {
    var _state$activeShrinked2;
    const entity = state.activeTab || ((_state$activeShrinked2 = state.activeShrinkedTab) === null || _state$activeShrinked2 === void 0 ? void 0 : _state$activeShrinked2.value);
    formExtraField.current.open({
      entities,
      entity
    });
  }, [state.activeShrinkedTab, state.activeTab]);
  const onEditExtraField = useCallback((row, entities, tabs, entity, duplicate) => {
    setActiveRowId(row.id);
    formExtraField.current.open({
      id: row.idDb,
      entities,
      tabs,
      entity,
      duplicate
    });
  }, []);
  const onCreateFieldsTab = useCallback(entities => {
    formTab.current.open({
      entities,
      entity
    });
  }, [entity]);
  const onEditFieldsTab = useCallback((row, entities) => {
    setActiveRowId(row.id);
    const data = state.fieldsData[entity].fields.tab.find(el => el.id === row.idDb);
    formTab.current.open({
      data,
      entities,
      entity: entity
    });
  }, [entity, state.fieldsData]);
  const onReorderTabs = useCallback((entityName, row) => {
    var _state$fieldsData, _state$fieldsData$ent;
    setActiveRowId(row.id);
    dispatch({
      type: 'SET_TABS_MODAL',
      data: {
        isOpen: true,
        order: (_state$fieldsData = state.fieldsData) === null || _state$fieldsData === void 0 ? void 0 : (_state$fieldsData$ent = _state$fieldsData[entity]) === null || _state$fieldsData$ent === void 0 ? void 0 : _state$fieldsData$ent.tabsOrder
      }
    });
  }, [entity, state.fieldsData]);
  const onReorderExtraFields = useCallback((tabId, extraOrder) => {
    dispatch({
      type: 'SET_EXTRA_ORDER',
      entity,
      tabId,
      extraOrder
    });
  }, [entity]);
  const onCloseTabsModal = useCallback(() => {
    setActiveRowId(null);
    dispatch({
      type: 'SET_TABS_MODAL',
      data: {
        isOpen: false,
        order: []
      }
    });
  }, []);
  const onConfirmTabsModal = useCallback(() => {
    var _state$tabsModal, _state$tabsModal$orde;
    logEvent({
      event: entityLogName,
      submodule: state.entityLogSubmodule,
      functionality: 'sortTab'
    });
    const tabsOrder = (_state$tabsModal = state.tabsModal) === null || _state$tabsModal === void 0 ? void 0 : (_state$tabsModal$orde = _state$tabsModal.order) === null || _state$tabsModal$orde === void 0 ? void 0 : _state$tabsModal$orde.map((el, i) => ({
      id: el,
      order: i
    }));
    updateTabsOrder(tabsOrder).then(() => {
      setActiveRowId(null);
      dispatch({
        type: 'SET_TABS_ORDER',
        entity,
        tabsOrder
      });
      publish(FIELDS_REFRESH);
    }).catch(err => {
      console.warn(err);
    });
  }, [entity, logEvent, state.entityLogSubmodule, (_state$tabsModal2 = state.tabsModal) === null || _state$tabsModal2 === void 0 ? void 0 : _state$tabsModal2.order]);
  const onSetTabsOrder = useCallback(order => {
    dispatch({
      type: 'SET_TABS_MODAL',
      data: {
        isOpen: true,
        order
      }
    });
  }, []);
  const refreshList = useCallback(() => {
    publish(FIELDS_REFRESH);
    onUpdate && onUpdate();
  }, [onUpdate]);
  const getEntityData = useCallback(entity => {
    return new Promise((resolve, reject) => {
      getMappedFieldList(entity, language, t, customGeneralTab).then(data => {
        if (!data) {
          reject();
        } else {
          dispatch({
            type: 'SET_FIELDS_LIST_AND_ORDERS',
            entity,
            data
          });
          resolve(data);
        }
      }).catch(reject);
    });
  }, [language, customGeneralTab, t]);
  const processDataBeforeSave = useCallback(data => {
    var _Object$keys;
    if (!data || ((_Object$keys = Object.keys(data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0) return data;
    return Object.entries(data).reduce((obj, _ref3) => {
      let [key, value] = _ref3;
      if (key === 'customValidation' && !value) {
        obj[key] = -1;
      } else {
        obj[key] = value;
      }
      return obj;
    }, {});
  }, []);
  const onOpenUpgradeTabsInfo = useCallback(() => {
    dispatch({
      type: 'SET_UPGRADE_INFO_TABS',
      value: true
    });
    setTimeout(() => {
      document.dispatchEvent(new Event('click'));
    });
  }, []);
  const onCloseUpgradeTabsInfo = useCallback(() => {
    dispatch({
      type: 'SET_UPGRADE_INFO_TABS',
      value: false
    });
  }, []);
  const onConfirmUpgradeTabsInfo = useCallback(() => {
    handleUpgradePlan && handleUpgradePlan();
    dispatch({
      type: 'SET_UPGRADE_INFO_TABS',
      value: false
    });
  }, [handleUpgradePlan]);
  const onOpenUpgradeAdminInfo = useCallback(() => {
    dispatch({
      type: 'SET_UPGRADE_INFO_ADMIN',
      value: true
    });
  }, []);
  const onCloseUpgradeAdminInfo = useCallback(() => {
    dispatch({
      type: 'SET_UPGRADE_INFO_ADMIN',
      value: false
    });
  }, []);
  const onConfirmUpgradeAdminInfo = useCallback(() => {
    handleUpgradePlan && handleUpgradePlan();
    dispatch({
      type: 'SET_UPGRADE_INFO_ADMIN',
      value: false
    });
  }, [handleUpgradePlan]);
  const upgradeTabsProps = useMemo(() => ({
    title: t('label_upgrade_to_create_new_tabs'),
    content: t('label_upgrade_to_create_new_tabs_desc'),
    videoSrc: t('label_upgrade_to_create_new_tabs_video')
  }), [t]);
  const upgradeToAdminProps = useMemo(() => ({
    title: t('label_upgrade_to_admin'),
    content: t('label_upgrade_to_admin_desc'),
    videoSrc: t('label_upgrade_to_admin_video')
  }), [t]);
  useEffect(() => {
    overrideActiveTab && onChangeTab(overrideActiveTab);
  }, [onChangeTab, overrideActiveTab]);
  return /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "field-list",
    show: true
  }, /*#__PURE__*/React.createElement(FieldsLists, {
    entity: entity,
    branches: state.branches,
    onChangeTab: onChangeTab,
    onChangeShrinked: onChangeShrinked,
    activeShrinkedTab: state.activeShrinkedTab,
    activeTab: state.activeTab,
    onEditStandardField: onEditStandardField,
    onCreateExtraField: onCreateExtraField,
    onEditExtraField: onEditExtraField,
    onCreateFieldsTab: onCreateFieldsTab,
    onEditFieldsTab: onEditFieldsTab,
    onReorderTabs: onReorderTabs,
    fieldsData: state.fieldsData,
    entityData: (_state$fieldsData2 = state.fieldsData) === null || _state$fieldsData2 === void 0 ? void 0 : _state$fieldsData2[entity],
    getEntityData: getEntityData,
    onReorderExtraFields: onReorderExtraFields,
    idSetupRole: idSetupRole,
    activeRowId: activeRowId,
    setActiveRowId: setActiveRowId,
    entityLogName: entityLogName,
    entityLogSubmodule: state.entityLogSubmodule,
    overrides: overrides,
    onUpdate: onUpdate,
    onOpenUpgradeTabsInfo: onOpenUpgradeTabsInfo
  })), /*#__PURE__*/React.createElement(FormStandardField, {
    onRef: ref => formStandardField.current = ref,
    refreshList: refreshList,
    setActiveRowId: setActiveRowId,
    idSetupRole: idSetupRole,
    processDataBeforeSave: processDataBeforeSave,
    entityLogName: entityLogName,
    entityLogSubmodule: state.entityLogSubmodule,
    overrides: overrides,
    onOpenUpgradeAdminInfo: onOpenUpgradeAdminInfo
  }), /*#__PURE__*/React.createElement(FormExtraField, {
    onRef: ref => formExtraField.current = ref,
    refreshList: refreshList,
    fieldsData: state.fieldsData,
    getEntityData: getEntityData,
    idSetupRole: idSetupRole,
    setActiveRowId: setActiveRowId,
    processDataBeforeSave: processDataBeforeSave,
    entityLogName: entityLogName,
    entityLogSubmodule: state.entityLogSubmodule,
    onOpenUpgradeTabsInfo: onOpenUpgradeTabsInfo,
    onOpenUpgradeAdminInfo: onOpenUpgradeAdminInfo,
    entity: entity,
    overrides: overrides
  }), /*#__PURE__*/React.createElement(FormTab, {
    onRef: ref => formTab.current = ref,
    refreshList: refreshList,
    fieldsData: state.fieldsData,
    getEntityData: getEntityData,
    idSetupRole: idSetupRole,
    setActiveRowId: setActiveRowId,
    overrides: _objectSpread(_objectSpread({}, overrides), {}, {
      fieldsToHide: overrides !== null && overrides !== void 0 && overrides.isWeb && overrides !== null && overrides !== void 0 && (_overrides$formTabFie = overrides.formTabFieldsToHide) !== null && _overrides$formTabFie !== void 0 && _overrides$formTabFie.length ? overrides.formTabFieldsToHide : []
    })
  }), /*#__PURE__*/React.createElement(Modal, {
    title: t('cfm_label_sort_tabs'),
    isOpen: state.tabsModal.isOpen,
    onRequestClose: onCloseTabsModal,
    onCancel: onCloseTabsModal,
    onConfirm: onConfirmTabsModal,
    cancelText: t('cfm_action_close'),
    confirmText: t('cfm_action_save')
  }, /*#__PURE__*/React.createElement(TabsLists, {
    list: (_state$fieldsData3 = state.fieldsData) === null || _state$fieldsData3 === void 0 ? void 0 : (_state$fieldsData3$en = _state$fieldsData3[entity]) === null || _state$fieldsData3$en === void 0 ? void 0 : (_state$fieldsData3$en2 = _state$fieldsData3$en.fields) === null || _state$fieldsData3$en2 === void 0 ? void 0 : _state$fieldsData3$en2.tab,
    order: (_state$tabsModal3 = state.tabsModal) === null || _state$tabsModal3 === void 0 ? void 0 : _state$tabsModal3.order,
    setOrder: onSetTabsOrder,
    overrides: overrides
  })), /*#__PURE__*/React.createElement(AddOnInfo, _extends({
    isOpen: state.isUpgradeInfoTabsOpen,
    onRequestClose: onCloseUpgradeTabsInfo,
    onCancel: onCloseUpgradeTabsInfo,
    onConfirm: isSage ? null : onConfirmUpgradeTabsInfo,
    cancelText: t('action_cancel'),
    confirmText: isSage ? null : t('action_upgrade')
  }, upgradeTabsProps)), isWeb && /*#__PURE__*/React.createElement(AddOnInfo, _extends({
    isOpen: state.isUpgradeInfoAdminOpen,
    onRequestClose: onCloseUpgradeAdminInfo,
    onCancel: onCloseUpgradeAdminInfo,
    onConfirm: isSage ? null : onConfirmUpgradeAdminInfo,
    cancelText: t('action_cancel'),
    confirmText: isSage ? null : t('action_upgrade')
  }, upgradeToAdminProps)));
};
process.env.NODE_ENV !== "production" ? Fields.propTypes = {} : void 0;
export default /*#__PURE__*/memo(Fields);